import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import ReactPlayer from 'react-player';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import * as classes from './VideosSection.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { VideosSectionProps } from '../../../../../Sections/Gallery/VideosSection/VideosSection';

SwiperCore.use([Navigation, Autoplay]);

const VideosSection: FC<VideosSectionProps> = ({ items }) => {
  const { t } = useTranslation();

  const videosMapper = (item: string, index: number) => (
    <SwiperSlide key={index}>
      <div className={classes.videoWrapper}>
        <ReactPlayer controls url={item} config={{ vimeo: { playerOptions: { responsive: true } } }} />
      </div>
    </SwiperSlide>
  );

  return (
    <div className={classes.wrapper}>
      <Section number={'02'} label={t('gallery.videos.sectionTitle')}>
        <Container>
          <div className={classes.spacer} />
          <div className={'swiper-default-template'}>
            <Swiper slidesPerView={'auto'} spaceBetween={16} navigation={true}>
              {items.map(videosMapper)}
            </Swiper>
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default VideosSection;
